import './PromptTableActionButtonGroup.scss';

import React, { FC, MouseEvent } from 'react';
import { Button } from 'react-bootstrap';
import ButtonGroup from 'react-bootstrap/esm/ButtonGroup';
import { Link } from 'react-router-dom';

interface PromptTableActionButtonGroupProps {
  entityContainerUrl: string;
  entityId: number;
  entitySlug: string;
  isViewOnly: boolean;
  onDelete: (id: number) => void;
}

const PromptTableActionButtonGroup: FC<PromptTableActionButtonGroupProps> = ({
  entityContainerUrl,
  entityId,
  // eslint-disable-next-line unused-imports/no-unused-vars
  entitySlug,
  isViewOnly,
  onDelete,
}) => {
  const deleteMessage =
    'Are you sure you want to delete this record?  This action is unreversible. ';

  return (
    <div className="TableActionButtonGroup">
      <ButtonGroup aria-label="Document Actions">
        { isViewOnly ?
          (<> </>
          // <Link
          //   // to={`/${entityContainerUrl}/view/${entityId}`}
          //   to={`https://www.blabberjax.com/ai-prompt-template-${entitySlug}`}
          //   target="_blank"
          //   className="btn btn-primary"
          //   title="View"
          // >
          //   <i className="bi bi-eye" />
          // </Link>
          ) :
          (
            <Link
              to={`/${entityContainerUrl}/edit/${entityId}`}
              className="btn btn-secondary"
              title="Edit"
            >
              <i className="bi bi-pencil" />
            </Link>
          )
        }
        
        <Link
          to={`/${entityContainerUrl}/edit/new?fromId=${entityId}`}
          className="btn btn-info"
          title="Copy"
        >
          <i className="bi bi-copy" />
        </Link>
        
        { isViewOnly ?
          (<> </>
          ) : 
          (
            <Button
              variant="danger"
              title="Delete"
              onClick={(event: MouseEvent) => {
                event.preventDefault();
                // eslint-disable-next-line no-alert
                if (window.confirm(deleteMessage)) {
                  onDelete(entityId);
                }
              }}
            >
              <i className="bi bi-trash" />
            </Button>
          )
        }
      </ButtonGroup>
    </div>
  );
};

export default PromptTableActionButtonGroup;
